export enum SpecialDiscountTypeEnum {
    None = 0,
    PersonWithDisabilities = 1,
    Student = 2,
    SeniorCitizen = 3,
    Athlete = 4,
    Coach = 5
}
